import * as React from "react";
const TextBold = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16,6 L8,6 C6.35,6 5,7.35 5,9 L5,11 L7,11 L7,9 C7,8.448 7.447,8 8,8 L11,8 L11,17 L9,17 L9,19 L15,19 L15,17 L13,17 L13,8 L16,8 C16.553,8 17,8.448 17,9 L17,11 L19,11 L19,9 C19,7.343 17.657,6 16,6" }));
TextBold.displayName = "TextBold";
var TextBold_default = TextBold;
export {
  TextBold_default as default
};
